import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AgentPersonalDetailResponse } from '@models/AgentPersonalDetailRequest.model';
import { MyInfoPersonResponse } from '@models/MyInfoRequest.model';
import { MyInfoForm,MyInfoAddressForm } from '@models/MLTC_R3/MyInfo.model';
import { DeclarationForm } from '@models/MLTC_R3/Declaration.model';
export interface Step4State {
  personalDetails: AgentPersonalDetailResponse | null;
  myInfoForm: MyInfoForm | null;
  myInfoAddressForm: MyInfoAddressForm | null;
  retrievedMyInfo: MyInfoPersonResponse | null;
  declaration: DeclarationForm | null;
  isCompleted: boolean;

  // retrievedMyInfo: MyInfoPersonResponse | null;
  // addMyInfoPopup: AddMyInfoRequest | null;
  // addMyInfoResponse: any;
  hasMyInfo: boolean;
  // isCompleted: boolean;
  l400: any;
  myInfoRawResponse: any;
  isMyInfoStepCompleted:boolean;
  completedDeclarationStep:boolean;
  myInfoInTouchValue: {selected:string, value:string[]};
  customerId : number
}

const initialState: Step4State = {
  declaration: null,
  hasMyInfo: false,
  personalDetails: null,
  myInfoAddressForm: null,
  myInfoRawResponse: null,
  myInfoForm: new MyInfoForm(null),
  retrievedMyInfo: null,
  isCompleted: false,
  isMyInfoStepCompleted:false,
  completedDeclarationStep: false,
  myInfoInTouchValue: {selected:"", value:[]},
  l400: null,
  customerId: 0
}

const step4Slice = createSlice({
  name: 'MLTC-R3-Step4',
  initialState,
  reducers: {
    updateDeclaration: (state, action: PayloadAction<DeclarationForm | null>) => {
      state.declaration = action.payload;
    },
    updatePersonalDetails: (state, action: PayloadAction<AgentPersonalDetailResponse>) => {
      state.personalDetails = action.payload
    },
    updateMyInfoForm: (state, action: PayloadAction<MyInfoForm>) => {
      state.myInfoForm = action.payload
    },
    updateMyInfoAddressForm: (state, action: PayloadAction<MyInfoAddressForm>) => {
      state.myInfoAddressForm = action.payload
    },
    updateMyInfoRawResponse: (state, action: PayloadAction<any>) => {
      state.myInfoRawResponse = action.payload
    },
    updateRetrievedMyInfo: (state, action: PayloadAction<MyInfoPersonResponse>) => {
      state.retrievedMyInfo = action.payload
    },
    updateHasMyInfo: (state, action: PayloadAction<boolean>) => {
      state.hasMyInfo = action.payload
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    completeMyInfoStep: (state, action: PayloadAction<boolean>) => {
      state.isMyInfoStepCompleted = action.payload;
    },
    completeDeclarationStep:(state, action: PayloadAction<boolean>)=>{
      state.completedDeclarationStep = action.payload
    },
    updateL400: (state, action: PayloadAction<any>) => {
      state.l400 = action.payload
    },
    updateMyInfoInTouch: (state, action: PayloadAction<any>) => {
      state.myInfoInTouchValue = action.payload;
    },
    resetToIntialStateStep4: (state, action:PayloadAction<"">)=>({
      ...initialState
    })
  },
  extraReducers: {}
})

export const { 
  updateMyInfoAddressForm,
  updatePersonalDetails,
  updateMyInfoForm,
  updateMyInfoRawResponse,
  updateRetrievedMyInfo,
  completeStep,
  updateDeclaration,
  completeMyInfoStep,
  updateHasMyInfo,
  updateMyInfoInTouch,
  updateL400,
  completeDeclarationStep,
  resetToIntialStateStep4
} = step4Slice.actions;

export default step4Slice.reducer;